import { render, staticRenderFns } from "./ClientComplaints.vue?vue&type=template&id=3350c57a&"
import script from "./ClientComplaints.vue?vue&type=script&lang=ts&"
export * from "./ClientComplaints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports